<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules"  label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 财务打款</template>
                            <Row :gutter="32">
                                <Col span="24">
                                    <FormItem label="打款" prop="status" :rules="[{required: true, type:'number', message: '请选择打款结果', trigger: 'change',  transform(value) { return parseInt(value)}}]">
                                        <RadioGroup v-model="Forms.status" type="button" button-style="solid">
                                            <Radio :label="7">已打款</Radio>
                                            <Radio :label="6">打款驳回</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </Col>
                                <Col span="24" v-if="Forms.status === 6">
                                    <FormItem  label="驳回原因" prop="reject_remark" :rules="[{required: true, message: '请输入驳回原因', trigger: 'blur'}]">
                                        <Input v-model="Forms.reject_remark" type="textarea" :rows="4" clearable placeholder="驳回原因"  />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row :gutter="32" v-if="Forms.status === 7">
                                <Col span="8">
                                    <FormItem label="打款金额" prop="pay_money" :rules="[{ required: true, type: 'number',  message: '请输入打款金额', trigger: 'blur',  transform(value) { return parseFloat(value)}}]">
                                        <Input v-model="Forms.pay_money" type="number" class="width-100" clearable placeholder="如：10000" />
                                    </FormItem>
                                </Col>
                                <Col span="8">
                                    <FormItem label="打款时间" prop="pay_time" :rules="[{required: true, type:'date', message: '请选择打款时间', trigger: 'change'}]">
                                        <DatePicker type="date" format="yyyy-MM-dd" v-model="Forms.pay_time" placeholder="打款时间" class="width-100"  />
                                    </FormItem>
                                </Col>
                                <Col span="8">
                                    <FormItem label="收款账户" prop="pay_bank_account" :rules="[{ required: true, message: '请输入收款账户', trigger: 'blur'}]">
                                        <Input v-model="Forms.pay_bank_account" class="width-100" clearable placeholder="" />
                                    </FormItem>
                                </Col>
                                <Col span="8">
                                    <FormItem label="账户实名" prop="pay_bank_real_name" :rules="[{ required: true, message: '请输入账户实名', trigger: 'blur'}]">
                                        <Input v-model="Forms.pay_bank_real_name" class="width-100" clearable placeholder="" />
                                    </FormItem>
                                </Col>
                                <Col span="8">
                                    <FormItem label="收款银行" prop="pay_bank_name" :rules="[{ required: true, message: '请输入收款银行', trigger: 'blur'}]">
                                        <Input v-model="Forms.pay_bank_name" class="width-100" clearable placeholder="" />
                                    </FormItem>
                                </Col>
                                <Col span="8">
                                    <FormItem label="开户地址" prop="pay_bank_address" :rules="[{ required: true, message: '请输入开户地址', trigger: 'blur'}]">
                                        <Input v-model="Forms.pay_bank_address" class="width-100" clearable placeholder="" />
                                    </FormItem>
                                </Col>
                                <Col span="24">
                                    <FormItem label="付款凭证" prop="pay_image" :rules="[{required: true, validator(rule, value, callback){ if(!value || value.length === 0 || !value[0]){ return callback(new Error('请上传付款凭证')) } callback() }, trigger: 'change'}]">
                                        <Input v-model="Forms.pay_image[0]" disabled>
                                            <template #append>
                                                <div class="f-center">
                                                    <Upload
                                                        :show-upload-list="false"
                                                        :action="upload_url"
                                                        :headers = "{'token': $store.state.token}"
                                                        :format="['xls','xlsx','rar','zip','doc','docx','txt','jpg','jpeg','png','pdf']"
                                                        :max-size="50 * 1024"
                                                        :on-success="handleSuccess"
                                                        :on-format-error="handleFormatError"
                                                        :on-exceeded-size="handleMaxSize">
                                                        <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                                    </Upload>
                                                    <Divider type="vertical" />
                                                    <a href="javascript:void(0);" @click="FileDelete('pay_image')" class="text-danger"><Icon type="md-trash" />删除</a>
                                                    <Divider type="vertical" />
                                                    <a href="javascript:void(0);" @click="FileDownload(Forms.pay_image[0])" class="text-violet"><Icon type="md-download" />下载</a>
                                                </div>
                                            </template>
                                        </Input>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 支出信息</template>
                            <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                                <Description term="零星项目：">
                                    {{detail.project_name}}
                                </Description>
                                <Description term="甲方：">
                                    {{detail.customer_name ?? '-'}}
                                </Description>
                                <Description term="维保记录：">
                                    {{detail.maintain_title ?? '-'}}
                                </Description>
                                <Description term="供应商：">
                                    {{detail.company ?? '-'}}
                                </Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="4"  layout="vertical">
                                <Description term="不含税金额：">
                                    <Tag color="blue">{{detail.money}}</Tag>
                                </Description>
                                <Description term="费率：">
                                    <Tag>{{detail.tax_rate}} %</Tag>
                                </Description>
                                <Description term="税费：">
                                    <Tag>{{detail.tax_money}}</Tag>
                                </Description>
                                <Description term="含税金额：">
                                    <Tag color="green">{{detail.true_money}}</Tag>
                                </Description>
                                <Description term="支出说明：">
                                    {{detail.content || '-'}}
                                </Description>
                                <Description term="收款账户：">
                                    {{detail.pay_bank_account}}
                                </Description>
                                <Description term="账户实名：">
                                    {{detail.pay_bank_real_name}}
                                </Description>
                                <Description term="开户银行：">
                                    {{detail.pay_bank_name}}
                                </Description>
                                <Description term="申请人：">
                                    {{detail.apply_name}}
                                </Description>
                                <Description term="申请时间：">
                                    {{detail.apply_time}}
                                </Description>
                            </DescriptionList>
                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认打款</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getDispersedExpendDetail, payDispersedExpend} from "@/apis/dispersed";

export default {
    name: 'DispersedExpendPay',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '财务打款',
            isBox : false,
            detail: [],
            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,
            Forms : {
                expend_id: '',
                status: '',
                reject_remark: '',
                pay_money: '',
                pay_time: '',
                pay_bank_account: '',
                pay_bank_real_name: '',
                pay_bank_name: '',
                pay_bank_address: '',
                pay_image: [],
            },
            Rules : {

            }
        }
    },
    methods: {
      /**
       功能：附件删除
       time: 2026/09/12
       **/
      FileDelete(f){
        let that = this;
        that.Forms[f] = [];
      },
      /**
       功能：附件下载
       time: 2026/09/12
       **/
      FileDownload(url){
        let that = this;
        if(url){
          //下载文件
          const fileUrl = that.site_url + url; // 文件的URL地址
          const parts = fileUrl.split('/');
          const fileName = parts[parts.length - 1];
          const link = document.createElement('a');
          link.href = fileUrl;
          link.target = '_blank';
          link.setAttribute('download', fileName);
          link.click();
        }else{
          that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
        }
      },
        /**
         功能：上传成功
         time: 2026/09/12
         **/
        handleSuccess(res){
            let that = this;
            if(res.code === 100){
                this.Forms.pay_image = [res.data.url];
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | pdf | doc | docx | xls | xlsx | rar | zip 文件' });
            return false;
        },
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },
        /**
         功能：详情
         time: 2026/09/12
         **/
        GetDetail(expend_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getDispersedExpendDetail(expend_id).then(e => {
                that.detail = e.data;
                //打款金额默认含税金额
                that.Forms.pay_money = e.data.true_money ?? e.data.money ?? '';
                //打款时间默认今天
                that.Forms.pay_time = new Date();
                //收款信息默认支出记录数据
                that.Forms.pay_bank_account = e.data.pay_bank_account ?? '';
                that.Forms.pay_bank_real_name = e.data.pay_bank_real_name ?? '';
                that.Forms.pay_bank_name = e.data.pay_bank_name ?? '';
                that.Forms.pay_bank_address = e.data.pay_bank_address ?? '';
            })
        },
        /**
         功能：打开
         time: 2026/09/12
         **/
        show(expend_id){
            this.isBox = true;
            if(expend_id){
                this.Forms.expend_id = expend_id;
                this.GetDetail(expend_id);
            }
        },
        /**
         功能：提交
         time: 2026/09/12
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    //打款时间 Date 对象转 yyyy-MM-dd 字符串
                    let payTime = that.Forms.pay_time;
                    if(payTime && typeof payTime !== 'string'){
                        const d = new Date(payTime);
                        const month = String(d.getMonth() + 1).padStart(2, '0');
                        const day = String(d.getDate()).padStart(2, '0');
                        payTime = d.getFullYear() + '-' + month + '-' + day;
                    }
                    let param = JSON.parse(JSON.stringify(that.Forms));
                    param.pay_time = payTime;
                    that.$store.commit('SET_LOADING' , true);
                    payDispersedExpend(param).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：重置
         time: 2026/09/12
         **/
        FormReset(){
            this.isBox = false;
            this.title = '财务打款';
            this.$refs['Forms'].resetFields();
            this.Forms = {
                expend_id: '',
                status: '',
                reject_remark: '',
                pay_money: '',
                pay_time: '',
                pay_bank_account: '',
                pay_bank_real_name: '',
                pay_bank_name: '',
                pay_bank_address: '',
                pay_image: [],
            };
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
